/* Align the header overflow ("Contact Us") card under its trigger.
   The card is rendered inside overflow-list's shadow root, laid out in a
   full-width hover bridge, so CSS alone cannot know the trigger's x
   position. This measures it and hands it to sts-bright.css via
   --sts-overflow-card-margin (which falls back to right-aligned). */
(() => {
  const menus = () => document.querySelectorAll('#header-component overflow-list.overflow-menu');

  const align = (om) => {
    const sr = om.shadowRoot;
    if (!sr) return;
    const trigger = sr.querySelector('slot[name="more"]');
    const bridge = sr.querySelector('[part="overflow"]');
    const card = sr.querySelector('[part="overflow-list"]');
    if (!trigger || !bridge || !card || trigger.hasAttribute('hidden')) return;
    const t = trigger.getBoundingClientRect();
    const b = bridge.getBoundingClientRect();
    if (!t.width || !b.width) return;
    const cardWidth = card.getBoundingClientRect().width || 260;
    const left = Math.max(8, Math.min(t.left - b.left, b.width - cardWidth - 8));
    om.style.setProperty('--sts-overflow-card-margin', Math.round(left) + 'px auto');
  };

  const alignAll = () => menus().forEach(align);

  const init = () => {
    menus().forEach((om) => {
      om.addEventListener('pointerenter', () => align(om));
      om.addEventListener('focusin', () => align(om));
    });
    alignAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The component's own ResizeObserver watches the overflow-list element,
     which is content-sized once items have collapsed — shrinking the window
     squeezes it (observer fires, items collapse) but growing the window
     never widens it, so collapsed items stayed hidden. Ask the component to
     re-measure via its public "reflow" event whenever the window resizes or
     the header row changes size (which tracks the space actually available). */
  let resizeTimer;
  const requestReflow = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      menus().forEach((om) => om.dispatchEvent(new CustomEvent('reflow', { detail: {} })));
      alignAll();
    }, 150);
  };
  window.addEventListener('resize', requestReflow);
  if (window.ResizeObserver) {
    const observed = new Set();
    const ro = new ResizeObserver(requestReflow);
    const observe = () => {
      menus().forEach((om) => {
        const row = om.closest('.header__columns') || om.closest('header-menu');
        if (row && !observed.has(row)) {
          observed.add(row);
          ro.observe(row);
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observe);
    } else {
      observe();
    }
  }
})();
